import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const CampaignFlow: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>{t('campaignFlow')}</Typography>
      </div>
      <div className={classes.scrollContent}>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('startBuildingCampaignFlow')}</Typography>
          <Typography className={classes.sectionText}>{t('startBuildingCampaignFlowDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('typesOfActionsInCampaign')}</Typography>
          <Typography className={classes.sectionText}>{t('typesOfActionsInCampaignDescription')}</Typography>
          <ul className={classes.sectionList}>
            <Typography component="li" className={classes.sectionText}>
              {t('actionLinkedInRequest')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('actionDirectMessages')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('actionInMails')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('actionEmailFollowUps')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('actionEngagementActions')}
            </Typography>
          </ul>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('setupWaitingTimes')}</Typography>
          <Typography className={classes.sectionText}>{t('setupWaitingTimesDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('whatAreConditionals')}</Typography>
          <Typography className={classes.sectionText}>{t('whatAreConditionalsDescription')}</Typography>
          <ul className={classes.sectionList}>
            <Typography component="li" className={classes.sectionText}>
              {t('conditionalAcceptConnection')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('conditionalNoResponse')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('conditionalPositiveReply')}
            </Typography>
          </ul>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('customizeAIMessages')}</Typography>
          <Typography className={classes.sectionText}>{t('customizeAIMessagesDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('handlingNoResponseRequests')}</Typography>
          <Typography className={classes.sectionText}>{t('handlingNoResponseRequestsDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('automaticResponsesNegativeReplies')}</Typography>
          <Typography className={classes.sectionText}>{t('automaticResponsesNegativeRepliesDescription')}</Typography>
        </section>
      </div>
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    padding: '24px 64px',
  },
  title: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  scrollContent: {
    padding: '0 64px 32px 64px',
    overflow: 'auto',
  },
  section: {
    marginTop: '32px',
    '&:first-of-type': {
      marginTop: '0px',
    },
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    marginBottom: '8px',
  },
  sectionText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.secondary,
  },
  sectionList: {
    marginTop: '8px',
    marginBottom: '8px',
    paddingLeft: '32px',
    '& li': {
      marginBottom: '4px',
    },
  },
}));

export default CampaignFlow;
